var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.params.token)?_c('h1',{staticClass:"text-center teal--text"},[_vm._v(" Subscripción Cancelada ")]):_c('h1',{staticClass:"text-center teal--text"},[_vm._v(" Subscripción Cancelada con exito ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }